import { SelectUserProps } from '../../userVerificationModal.types';
import styles from '../../userVerificationModal.module.css';
import { Trans } from 'react-i18next';
import { GetUsersResponse } from '@inplay/models';
import Button from '../../../button/button';
import { FC } from 'react';
import MultiSelectDropdown from '../../../multiSelectDropdown/multiSelectDropdown';

export const SelectUserContent: FC<SelectUserProps> = (
  props: SelectUserProps,
) => (
  <div className={styles.content}>
    <h3 className={styles.title}>
      <Trans i18nKey={'userVerification.title'} />
    </h3>
    <p className={styles.descriptionSelectUser}>
      <Trans i18nKey="userVerification.pleaseSelect" />{' '}
      <span>
        <Trans i18nKey="userVerification.next" />
      </span>{' '}
      <Trans i18nKey="userVerification.continue" />
    </p>
    <div className={styles.selectUsername}>
      <label>
        <Trans i18nKey="userVerification.username" />
      </label>
      <MultiSelectDropdown
        options={
          props.authUsersSummary && props.validAuthToken
            ? props.authUsersSummary.map((authUsers: GetUsersResponse) => ({
                label: `${authUsers.firstName} ${authUsers.lastName}`,
                value: authUsers.id,
              }))
            : []
        }
        selected={props.selectedUser?.userId || ''}
        placeholder="Select your name"
        onSelect={(value: string | string[]) =>
          props.handleOnSelectUser(value as string)
        }
      />
    </div>
    <Button
      className={styles.next}
      onClick={() => props.handleNext()}
      disabled={!props.selectedUser}
    >
      <Trans i18nKey="userVerification.next" />
    </Button>
  </div>
);
